module.exports = __webpack_public_path__ + "img/gh0.e2960d58.png";